import { debounce } from 'lodash';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { AppContext } from '@/Module/Core/Context';
import { getDeviceTypeByUserAgent } from '@/Module/Core/Helper';
import type { IAppContext, IProps } from '@/Module/Core/Model/DataModel';
import { DeviceType } from '@/Module/Core/Model/Enum';
interface IApplicationContextProps extends IProps {
  userAgent?: string;
}
const ApplicationContext: FC<IApplicationContextProps> = ({
  userAgent,
  children
}) => {
  const defaultDeviceType = useMemo(() => getDeviceTypeByUserAgent(userAgent ?? ''), []);
  const [deviceType, setDeviceType] = useState<IAppContext['deviceType']>(defaultDeviceType);
  const updateDeviceTypeBySize = () => {
    const currentDeviceType = window.innerWidth < 768 ? DeviceType.MOBILE : DeviceType.DESKTOP;
    setDeviceType(currentDeviceType);
  };
  useEffect(() => {
    if (defaultDeviceType !== DeviceType.DESKTOP) return () => {};
    const onWindowsResize = debounce(updateDeviceTypeBySize, 500);
    window.addEventListener('resize', onWindowsResize);
    updateDeviceTypeBySize();
    return () => {
      window.removeEventListener('resize', onWindowsResize);
    };
  }, []);
  const contextValue: IAppContext = useMemo(() => ({
    deviceType
  }), [deviceType]);
  return <AppContext.Provider value={contextValue} data-sentry-element="unknown" data-sentry-component="ApplicationContext" data-sentry-source-file="ApplicationContext.tsx">{children}</AppContext.Provider>;
};
export default ApplicationContext;